import { useState, memo } from "react";
import { useForm, FieldValues } from "react-hook-form";
import { clsx } from "clsx";
import { ReactComponent as RgLogo } from "components/icons/RGLogo.svg";
import { toast } from "react-hot-toast";
import { BaseButton } from "components/buttons/BaseButton";
import { IMG_TYPES } from "./constants";
import "./styles/CreateForm.scss";

interface ICreateFormProps {
  onSubmit: (data: FieldValues) => void;
}

export const CreateForm = memo(({ onSubmit }: ICreateFormProps) => {
  const [previewImage, setPreviewImage] = useState<any>(null);
  const [showImgError, setShowImgError] = useState(false);
  const {
    register,
    handleSubmit,
    formState: { errors, isValid, isSubmitting }
  } = useForm({
    mode: "all",
    defaultValues: { image: null, name: "", description: "", rules: "" }
  });

  const checkFileAndSetPreview = (value: any) => {
    if (!IMG_TYPES.includes(value[0].type)) {
      setPreviewImage(null);
      setShowImgError(true);
      if (!showImgError) {
        toast.error("Invalid file type. Please select a JPEG or PNG file.");
      }
      return false;
    }

    const reader = new FileReader();
    reader.onloadend = () => {
      setPreviewImage(reader.result);
    };
    reader.readAsDataURL(value[0]);
    setShowImgError(false);

    return true;
  };

  return (
    <form className="CreateForm" onSubmit={handleSubmit(onSubmit)}>
      <div className={clsx("NicheAvatar", errors["image"] && "NicheAvatar_WithError")}>
        {!previewImage && <RgLogo />}
        {previewImage && <img src={previewImage} alt="text" />}
        <input
          {...register("image", {
            required: true,
            validate: { checkFile: checkFileAndSetPreview }
          })}
          type="file"
          accept="image/png, image/jpeg"
        />
        <div className="NicheAvatar-Description">Choose an image</div>
      </div>
      <div className={clsx("InputWrap", errors["name"] && "InputWrap_WithError")}>
        <label className="InputWrap-Label" htmlFor="name">
          Name
          <input
            {...register("name", { required: true })}
            className="InputWrap-Input"
            placeholder="My Niche Name!"
            type="text"
            id="name"
          />
        </label>
        {errors["name"] && <p>Give your niche a unique name</p>}
      </div>
      <div className={clsx("InputWrap", errors["description"] && "InputWrap_WithError")}>
        <label className="InputWrap-Label" htmlFor="description">
          Description
          <textarea
            {...register("description", { required: true })}
            className="InputWrap-Input"
            placeholder="This is description of my niche"
            id="description"
            rows={3}
          />
        </label>
        {errors["description"] && <p>Let other users know what this niche is about</p>}
      </div>
      <div className={clsx("InputWrap", errors["rules"] && "InputWrap_WithError")}>
        <label className="InputWrap-Label" htmlFor="rules">
        Posting Guidelines
          <textarea
            {...register("rules", { required: true })}
            className="InputWrap-Input"
            placeholder="Be kind&#10;Be honest&#10;Be supportive"
            id="rules"
            rows={5}
          />
        </label>
        {errors["rules"] && <p>Let other users know what is expected of them</p>}
      </div>
      <div className="BtnWrap">
        <BaseButton type="submit" disabled={!isValid || isSubmitting}>
          {isSubmitting ? "Uploading..." : "Submit"}
        </BaseButton>
      </div>
    </form>
  );
});

